import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

export default function OfflineBanner() {
  const online = useNetworkStatus();
  const { t } = useLanguage();
  if (online) return null;
  return (
    <div className="offline-banner" role="status" aria-live="polite">
      <strong>{t('network.offlineTitle') || 'Offline'}</strong>
      <span>{t('network.offlineBody') || 'Live updates are paused. Reconnect to refresh your ride.'}</span>
    </div>
  );
}
